import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialGroupService = {
    options: async (s1, s2) => {
        let url = `${API_URL}/material-groups/options/all`
        if (s1) url += `/${s1}`
        if (s2) url += `/${s2}`
        return axios.get(url).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
    },
    list: async () => axios.post(`${API_URL}/material-groups/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-groups/${id}`).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/material-groups/${id}`).then(({data}) => data).catch((err) => {throw err}),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-groups/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/material-groups`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialGroupService;